import { render } from "./ComprasCreate.vue?vue&type=template&id=ae7f8990&scoped=true"
import script from "./ComprasCreate.vue?vue&type=script&lang=js"
export * from "./ComprasCreate.vue?vue&type=script&lang=js"

import "./ComprasCreate.vue?vue&type=style&index=0&id=ae7f8990&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7f8990"]])

export default __exports__